<template>
    <div>
        <el-row v-if="isConfirmationSuccessfully" style="align: center" class="row" v-loading="isLoading">
            <el-col class="vertical-center register-base-info" style="height: 100%">
                <h1 id="register_base_info_title">{{$t("register.registerMemberTitle")}}</h1>
                <h3 id="register_base_info_description">メールアドレスを確認できました。個人情報をご入力いただき、会員登録を完了してください。</h3>
                <el-form v-loading="loading">

                    <el-form-item prop="name" :label="$t('register.nameTitle')" style="font-weight: bold">
                        <el-input v-model="endUserBaseInfo.name" ref="name" type="text"
                                  @change="checkDisableConfirmButton" :placeholder="$t('register.namePlaceholder')"
                                  autocomplete="disabled"
                                  aria-autocomplete="none"></el-input>
                        <p style="color: red; margin-bottom: 0px" v-show="isNotFilled.name">
                            {{$t("common.requiredMessage")}}</p>
                    </el-form-item>

                    <SelectDate ref="selectDate"
                                @triggerToValidateData="triggerToValidateDataFromSelectDate"></SelectDate>
                    <p style="color: red; margin-top: -3px; margin-bottom: 0; font-weight: bold; font-size: 14px"
                       v-show="isNotFilled.birthDay">{{$t("common.requiredMessage")}}</p>

                    <el-form-item prop="national" :label="$t('register.nationalTitle')" style="font-weight: bold">
                        <el-select @change="checkDisableConfirmButton" v-model="endUserBaseInfo.nationalCode"
                                   style="width: 100%" type="text" :placeholder="$t('register.nationalPlaceholder')">
                            <el-option disabled value="">{{$t('register.nationalPlaceholder')}}</el-option>
                            <el-option v-for="national in nationals" :value="national.code" :label="national.name">
                                {{national.name}}
                            </el-option>
                        </el-select>
                        <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="isNotFilled.nationCode">
                            {{$t("common.requiredMessage")}}</p>
                    </el-form-item>

                    <el-form-item prop="gender" :label="$t('register.genderTitle')" style="font-weight: bold">
                        <div style="width: 100%; margin-left: 0px; display: inline-block">
                            <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="OTHER">
                            <label style="font-weight: normal" @click="setGender('OTHER')">{{$t('register.otherGender')}}</label>
                            <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="MALE" style="margin-left: 30px">
                            <label style="font-weight: normal" @click="setGender('MALE')">{{$t('register.maleGender')}}</label>
                            <input name="gender" v-model="endUserBaseInfo.gender" type="radio" value="FEMALE" style="margin-left: 30px">
                            <label style="font-weight: normal" @click="setGender('FEMALE')">{{$t('register.femaleGender')}}</label>
                        </div>
                        <p style="color: red; margin-top: -10px; margin-bottom: 0px" v-show="isNotFilled.gender">
                            {{$t("common.requiredMessage")}}</p>
                    </el-form-item>

                    <el-form-item prop="phone" :label="$t('changeEndUserInfo.phoneTitle')" >
                        <el-input v-model="endUserBaseInfo.phone" type="text"
                                  :placeholder="$t('changeEndUserInfo.phonePlaceholder')"
                                  autocomplete="disabled"
                                  aria-autocomplete="none"></el-input>
                    </el-form-item>

                    <el-form-item prop="isAllowedToReceiveEmail" :label="$t('register.acceptEmailTitle')"
                                  style="font-weight: bold">
                        <el-checkbox v-model="endUserBaseInfo.allowedToReceiveEmail" style="width: 100%">
                            {{$t('register.acceptEmailCheckbox')}}
                        </el-checkbox>
                    </el-form-item>

                    <el-form-item prop="personInformationRules" :label="$t('register.personalInformationRuleTitle')"
                                  style="font-weight: bold">
                        <div id="personal_information_rules_wrapper">
                            <div style="padding-left: 15px" v-html="personalInformationRules"></div>
                        </div>
                        <p style="color: red; margin-top: 0px; margin-bottom: 0px"
                           v-show="isNotFilled.acceptPersonInformationRules">{{$t("common.requiredMessage")}}</p>
                        <div style="text-align: center">
                            <el-checkbox @change="checkDisableConfirmButton"
                                         v-model="endUserBaseInfo.acceptedPersonInformationRules" style="width: 100%"
                                         type="">{{$t('register.personalInformationRuleCheckbox')}}
                            </el-checkbox>
                        </div>

                    </el-form-item>

                    <el-form-item style="width: 100%; display: inline-block; font-weight: bold" prop="useRules"
                                  :label="$t('register.useSystemRuleTitle')">
                        <div id="system_use_rules_wrapper">
                            <div style="padding-left: 15px" v-html="systemUseRules"></div>
                        </div>
                        <p style="color: red; margin-top: 0px; margin-bottom: 0px" v-show="isNotFilled.acceptUseRules">
                            {{$t("common.requiredMessage")}}</p>
                        <div style="text-align: center">
                            <el-checkbox @change="checkDisableConfirmButton" v-model="endUserBaseInfo.acceptedUseRules"
                                         style="width: 100%" type="">{{$t('register.useSystemRuleCheckbox')}}
                            </el-checkbox>
                        </div>
                    </el-form-item>

                    <el-form-item style="text-align: center">
                        <el-button id="confirm_button" @click="saveEndUserBaseInfo" :disabled="disableConfirmButton">
                            {{$t('register.confirmButton')}}
                        </el-button>
                    </el-form-item>

                </el-form>
            </el-col>
        </el-row>

        <el-row v-if="isExpiredOrPasswordWasNotConfirmed">
            <h2 style="color: red; text-align: center">{{$t("register.expiredOrInfoNotExactly")}}</h2>
        </el-row>
    </div>
</template>

<script>
    import UserAPI from "../../api/user/UserApi";
    import AlertService from "../../service/alert.service";
    import TextEditor from "../../components/TextEditor";
    import SelectDate from "../../components/SelectDate";

    export default {
        name: "RegisterEndUserBaseInfo",
        components: {SelectDate, TextEditor},
        data() {
            return {
                isExpiredOrPasswordWasNotConfirmed: false,
                isConfirmationSuccessfully: false,
                endUserBaseInfo: {
                    code: "",
                    name: "",
                    phone:"",
                    birthDay: "",
                    nationalCode: "31313100-0000-0000-0000-000000000000",
                    gender: "OTHER",
                    allowedToReceiveEmail: false,
                    acceptedPersonInformationRules: false,
                    acceptedUseRules: false,
                },

                systemUseRules: null,
                personalInformationRules: null,
                isOnlyRead: true,

                isNotFilled: {
                    name: false,
                    birthDay: false,
                    nationCode: false,
                    gender: false,
                    acceptPersonInformationRules: false,
                    acceptUseRules: false,
                },

                gender: "OTHER",
                loading: false,
                nationals: [],
                username: "",
                userCode: "",
                disableConfirmButton: true,
                isLoading: false,
            }
        },

        created() {
            this.username = this.$route.query.username;
            this.userCode = this.$route.query.endUserCode
            console.log(this.userCode)
            console.log(this.username)
            this.endUserBaseInfo.code = this.userCode;

            UserAPI.isPasswordConfirmedAndUnexpiredAndUserExist(this.username, this.userCode).then(result => {
                console.log(result)
                if (result) {
                    this.isConfirmationSuccessfully = true;
                    this.isExpiredOrPasswordWasNotConfirmed = false;
                    UserAPI.getNations().then(result => {
                        this.nationals = result;
                    });
                    UserAPI.getUseSystemRules().then(result => {
                        this.systemUseRules = result.rules;
                    })

                    UserAPI.getPersonalInformationRules().then(result => {
                        this.personalInformationRules = result.rules;
                    })

                } else {
                    this.isExpiredOrPasswordWasNotConfirmed = true;
                    this.isConfirmationSuccessfully = false;
                }
            })
        },

        methods: {
            setGender(gender) {
                this.endUserBaseInfo.gender = gender;
            },
            triggerToValidateDataFromSelectDate(date) {
                this.endUserBaseInfo.birthDay = date;
                this.validateData(this.endUserBaseInfo);
            },

            saveEndUserBaseInfo() {
                this.endUserBaseInfo.birthDay = this.$refs.selectDate.getSelectedDate();
                if (this.validateData(this.endUserBaseInfo)) {
                    this.isLoading = true;
                    //redirect to confirm information page
                    this.endUserBaseInfo.birthDay = this.$moment(new Date(this.endUserBaseInfo.birthDay)).format('YYYY/MM/DD HH:mm:ss');
                    console.log(this.endUserBaseInfo)
                    UserAPI.saveBaseInfo(this.endUserBaseInfo).then(result => {
                        this.isLoading = false;
                        this.$router.push({path: "/confirmRegisterInformation?username=" + result.username + "&endUserCode=" + result.code})
                    })
                } else {
                    AlertService.error(this.$t('register.pleaseEnterEnoughInformation'))
                }
            },

            validateData(endUserBaseInfo) {
                let vm = this;
                let isEnoughInfo = true;
                if (endUserBaseInfo.name == null || endUserBaseInfo.name.trim() == "") {
                    vm.isNotFilled.name = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.name = false;
                }

                if (endUserBaseInfo.birthDay == null || !new Date(endUserBaseInfo.birthDay).getTime()) {
                    vm.isNotFilled.birthDay = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.birthDay = false;
                }

                if (endUserBaseInfo.nationalCode == null || endUserBaseInfo.nationalCode.trim() == "") {
                    vm.isNotFilled.nationCode = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.nationCode = false;
                }

                if (endUserBaseInfo.gender == null || endUserBaseInfo.gender.trim() == "") {
                    vm.isNotFilled.gender = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.gender = false;
                }

                if (endUserBaseInfo.acceptedPersonInformationRules == false) {
                    vm.isNotFilled.acceptPersonInformationRules = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.acceptPersonInformationRules = false;
                }

                if (endUserBaseInfo.acceptedUseRules == false) {
                    vm.isNotFilled.acceptUseRules = true;
                    isEnoughInfo = false;
                } else {
                    vm.isNotFilled.acceptUseRules = false;
                }

                return isEnoughInfo;
            },

            checkDisableConfirmButton() {

                if (!this.validateData(this.endUserBaseInfo)) {
                    this.disableConfirmButton = true;

                } else {
                    this.disableConfirmButton = false;
                }
            }
        },
    }
</script>

<style scoped lang="scss">

    #register_base_info_title {
        font-weight: bold;
        font-size: 30px
    }

    .register-base-info {
        margin-left: 25%;
        margin-right: 25%;
    }

    #register_base_info_description {
        margin-left: 30px
    }

    #personal_information_rules_wrapper {
        width: 100%;
        display: inline-block;
        border: 1px solid #c2c2c2;
        max-height: 200px;
        overflow: scroll;
        margin-top: 10px
    }

    #system_use_rules_wrapper {
        width: 100%;
        display: inline-block;
        border: 1px solid #c2c2c2;
        max-height: 200px;
        overflow: scroll;
        margin-top: 10px
    }

    #confirm_button {
        width: 250px;
        background-color: #4B86E8;
        color: white
    }

    @media screen and (max-width: 1024px) {
        .register-base-info {
            margin-left: 0%;
            margin-right: 0%;
        }
    }

    #calendar_icon {
        cursor: pointer;
    }

    @media only screen and (max-width: 450px) {
        .register-base-info {
            margin-left: 0%;
            margin-right: 0%;
        }

        #confirm_button {
            width: 100%;
            background-color: #4B86E8;
            color: white
        }

        #register_base_info_title {
            font-weight: bold;
            font-size: 25px;
            text-align: center;
        }

        #register_base_info_description {
            margin-left: 0px;
            font-size: 16px;
            margin-top: 0px;
        }

        #personal_information_rules_wrapper {
            width: 100%;
            display: inline-block;
            border: 1px solid #c2c2c2;
            max-height: 150px;
            overflow: scroll;
            margin-top: 10px
        }

        #system_use_rules_wrapper {
            width: 100%;
            display: inline-block;
            border: 1px solid #c2c2c2;
            max-height: 150px;
            overflow: scroll;
            margin-top: 10px
        }
    }

</style>